import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useNemo from '../../api/useNemo';
import { Layout } from '../../components/layout/layout';
import { ROUTE } from '../../router';
import { GeneratedReport } from '../../store/types';
import EcoSection from '../sections/eco/eco-section';
import { GrowthSection } from '../sections/growth/growth-section';
import { IntoSection } from '../sections/intro/intro';
import SecuritySection from '../sections/security/security-section';
import SpeedSection from '../sections/speed/speed-section';
import { SupportSection } from '../sections/support/support';
import ThankYouSection from '../sections/thank-you/thank-you-section';

export const Personal: React.FC = () => {
  const { domain } = useParams();
  const [reportData, setReportData] = React.useState({} as GeneratedReport);
  const request = useNemo();
  const navigate = useNavigate();

  React.useEffect(() => {
    request({
      endpoint: `/yearly-recap/${domain}/show`,
      method: 'GET'
    })
      .then(({ data }) => setReportData(data))
      .catch(() => {
        // Invalid domain
        navigate(ROUTE.RECAP_GENERAL);
      });
  }, [request, domain, navigate]);

  const { carbon, security, speed, support } = reportData;

  return (
    <Layout>
      <IntoSection />
      <SpeedSection
        domain={domain}
        score={speed?.performance_reports?.score}
        percent_increase={speed?.migrated?.percent_increase}
      />
      <SecuritySection domain={domain} score={security?.security_reports?.score} />
      <GrowthSection domain={domain} />
      <EcoSection grams={carbon?.grams} score={carbon?.score} />
      <SupportSection
        average_resolution_time={support?.chat?.average_resolution_time}
        chat_interactions={support?.chat?.chat_interactions}
        asked_questions={support?.ai?.asked_questions}
      />
      <ThankYouSection hideSignupForm />
    </Layout>
  );
};
